export default __webpack_public_path__ + "static/media/background_login.f7499aaa.png";